import { CustomerShoppingInfoModel } from './../../models/customer-shoppingInfo.model';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import {MessageService} from 'primeng/api';

@Injectable()
export class CustomerShoppingInfoService {

  
  public baseUrlShopping = '/koncentro-customers/shopping';  

  constructor (private http: HttpClientService,  private srvNotify: MessageService) { }

  getShoppingLists(customerId: string): Observable<CustomerShoppingInfoModel[]> {
    return this.http.get(this.baseUrlShopping  + (customerId ? '?customer_host_id=' + customerId : '')).map(res => {
      return res;      
    });
  }
  getListDetails(listId: string): Observable<any> {
    return this.http.get(this.baseUrlShopping + '/' + (listId ? (listId + "/detail") : '')).map(res => {    
      return res;      
    });
  }
  deleteList(listId: string): Observable<any> {
    return this.http.delete(this.baseUrlShopping + "/" + listId).map(res => {
      this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'List deleted'});
      return res;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/customer/customer-shoppinginfo.service.ts